/* eslint-disable max-len */

import React from 'react'
import ThreeDotsLoader from '../../Components/LoadingDots'

export default function AcceptReject({type,setacceptRejectPopup,acceptRejectPopup,loading,setstatusloader,statusloader,handleStatusApprove,orderData}) {
    const distributor = orderData?.order?.work_flow_status === "3"?true:undefined;

    return (
        <div className="modal-dialog modal-dialog-centered relative pointer-events-none sm:max-w-[400px] w-full px-3 mx-auto z-50" style={{margin: 'auto'}}>
            <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                <div className="modal-header flex flex-shrink-0 items-center justify-between sm:p-5 pb-4 pt-6 px-1 rounded-t-md">
                    <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel2">
                        {acceptRejectPopup} {distributor?'EUB Order':'Draft Order'} 
                    </h5>
                    <button
                        onClick={()=>setacceptRejectPopup('')}
                        type="button"
                        className="btn-close1 box-content w-3.5 h-3.5 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute sm:top-4 top-2.5 right-2 sm:right-6"
                        data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body relative sm:px-9 px-3 sm:pt-1 pt-0 sm:pb-6 pb-4 text-center">
                    <p className="text-xs6 font-normal text-[#555259]">
                        Are you sure you want to {acceptRejectPopup} <br/> {distributor?'this EUB Order':'this Draft Order?'} 
                    </p>
                </div>
                <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly sm:pb-5 pb-4 rounded-b-md">
                    <button
                        onClick={()=>setacceptRejectPopup('')}
                        type="button"className="border border-[#555259] bg-[#FFFFFF] sm:text-xs6 text-sm font-normal text-[#555259] sm:py-3 py-2 sm:px-9 px-6 rounded-lg remove-product" data-bs-dismiss="modal" aria-label="Close">
                        Cancel
                    </button>
                    <button type="button"
                        onClick={()=>{
                            setstatusloader(true)
                            handleStatusApprove()
                        }}
                        className="bg-[#555259] font-normal text-[#ffffff] sm:text-xs6 text-sm sm:py-3 py-2 sm:px-12 px-9 rounded-lg draft-order" data-bs-dismiss="modal" aria-label="Close">
                        <>{statusloader?<ThreeDotsLoader/>:acceptRejectPopup}</> 
                    </button>
                </div>
            </div>
        </div>
    )
}
